import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { AllCampsiteFeaturesQuery } from '@custom/schema';

export const useAllCampsiteFeatures = () => {
  return useStaticQuery(graphql(AllCampsiteFeaturesQuery));
};
